export default {
	lvyoucuxiao: '旅行プロモーションで最大50%割引',
	guanzhuwomen: '私たちの50%割引に注目して',
	miyuetaocan: 'ハネムーンコース',
	lvyoucuxiaohuodong: '旅行キャンペーン',
	dujiatiantang: 'リゾート天国',
	zhongguo: '中国',
	yingguo: 'ニュージーランド.',
	aodaliya: 'オーストラリア',
	taiguo: 'タイ',
	xianggang: '香港',
	foluolidazhou: 'オークランド.',
	xini: 'シドニー',
	mangu: 'バンコク.',
	shanshuizhimei: '山水の美',
	xinxilandemeijing: 'ニュージーランドの美しい景色',
	xinigejuyuan: 'シドニーオペラハウス',
	zaimanguyaozuodeshiqing: 'バンコクでやること',
	lvyoucu: '旅行プロモーション',
	daizhewomende: '私たちのハネムーンコースを持ってロマンチックな天国に逃げた。あなたのプライベートヴィラで心身をリラックスさせ、スパトリートメントを受け、魅力的な海の景色を楽しむことができます。',
	tongguodaoyou: 'ガイドと料理コースを通じて現地文化を探る。詳細を整理して、これからあなたの幸せな生活を始めましょう。',
	lijiyuding: 'すぐに予約して、忘れられないハネムーンを過ごします。',
	jingdu: '京都4 d 3 n便+ホテルセット2点',
	pujidao: 'プーケットシーズンオフ4日間フライト+ホテルセット',
	xianggangfei: '香港から沖縄までの航空券',
	xinidaolundun: 'シドニー発ロンドン行きの航空券',
	malaixiyarelangdao: 'マレーシア、レダン島 + ビーチウォーク + 夜の青い涙を追いかける',
	yidianshan: 'エデンの山',
	aokelan: 'オークランド',
	pingfen: 'スコア',
	yidianshanjianjie: "オークランドの周りは海と火山に囲まれており、ランドマークの一つであるエデンの山は死火山に乗っている。エデンの山は今でもオークランドの原始的なマオリの砦を保存しており、オークランドを見下ろすのに良い場所でもある。",
	dibiaotiankongta: 'ランドマークスカイタワー',
	dibiaotiankongtajianjie: "塔の頂上360°の展望台は市街地を東西両岸に伸ばして全景を一望できる。晴れた日には周囲82キロの距離が見え、オークランドの夜景を楽しむのに最適な場所です。",
	habirencun: 'ハービー人村',
	habirencunjianjie: "魔戒ハービー人のあの世と争わないシエルの村は、多くの人が憧れている世界のはずだ！ニュージーランドの他の人家のない大自然の観光地に比べて、最もにぎやかなのはここであるべきで、一部の地域では混雑とさえ形容しなければならないので、この映画の影響力がどれだけ大きいかを見ることができます！",
	lanquan: '藍泉',
	lanquanjianjie: "ハービービレッジを見学すると、2時間で近くの秘景ブルースプリングスに着くことができ、ほとんどの人が行った後は幻想的に表現されます。泉水はマースク高原に源を発し、極めて純粋で、100年の層濾過を経て地表に到達する。ニュージーランドのペットボトルの水の70%がここから来ているそうですよ。",
	jiduchengzhiwuyuan: 'クライストチャーチ植物園',
	jiduchengzhiwuyuanjianjie: "クライストチャーチ植物園は、クライストチャーチ市民が日頃からくつろいでいるための公園です。園内にはたくさんのテーマガーデンがあり、ハーブ園、バラ園、温室ガーデンなど、四季を通じて美しい花が咲き誇り、ニュージーランドで最も素晴らしい植物園の一つです。",
	remenjingxuan: '人気の旅行ベスト',
	remenjingxuanbiaoti2: '人気の旅行ベスト',
	remenjingxuanmiaoshu2: '人気の観光ベスト、品質の選択、世界の素晴らしさを探して、完璧な休暇を楽しむことができます。',
	remenjingxuanlianjiemiaoshu2: '心身をリラックスさせたい、文化を体験したい、食事を楽しむなど、人気の旅行先とコースを厳選してお届けします。',
	remenjingxuanlianjie2: 'すぐに予約して、あなたの素晴らしい旅を開きます！',
	remenjingxuanbiaoti3: '期間限定スペシャルハネムーンコース',
	remenjingxuanmiaoshu3: '毎月のコース、専属ロマンチック、甘い時間、愛を目撃し、幸せな旅を開く。',
	remenjingxuanlianjiemiaoshu3: 'チャンスをつかんで、私たちがあなたのためにカスタマイズした期間限定のお得な旅行コースを楽しんでください。ビーチリゾート、都市探検、文化体験がお好きな方にも、最適な選択肢があります',
	remenjingxuanlianjie3: '今すぐ予約して、あなたの夢の旅を始めて、これらの得がたい特典を見逃さないでください！',
	remenjingxuanbiaoti4: '世界を探索し、恩恵を享受する',
	remenjingxuanmiaoshu4: '世界を探索して、すぐに出発して、割引を享受して、あなたのすばらしい旅を始めて、見逃さないでください',
	remenjingxuanlianjiemiaoshu4: '刺激を求める探検家であれ、リラックスしたいリゾート者であれ、私たちはあなたのニーズに応えることができます',
	remenjingxuanlianjie4: '今すぐ予約して、お得な特典を受けます',
	remenjingxuanbiaoti5: 'リゾート天国、専用カスタマイズ、完璧な休暇を作る',
	remenjingxuanmiaoshu5: 'リゾート天国、リラックスして、太陽の砂浜を楽しんで、悩みを吹き飛ばして、思い切り抱擁して美しい',
	remenjingxuanlianjiemiaoshu5: '私たちのハネムーンコースを持ってロマンチックな天国に逃げて、あなたのプライベート別荘で心身をリラックスさせて、スパの看護を楽しんで、魅力的な海の景色を鑑賞します',
	remenjingxuanlianjie5: '今すぐ予約して、これからあなたの幸せな生活を始めます！',
	xinjiapomangu: 'シンガポール発バンコク行き航空券',
	xinjiapoxianggang: 'シンガポール発香港行き航空券',
	xinjiapojilongpo: 'シンガポール発クアラルンプール行きの航空券',
	xinjiapoguangzhou: 'シンガポール発広州行き航空券',
	xinjiapoxini: 'シンガポール発シドニー行き航空券',
	xiangganglundun: '香港発ロンドン行きの航空券',
	xianggangxini: '香港発シドニー行き航空券',
	xinjiapobalidao: 'シンガポール発バリ島行きの航空券',
	xianggangyadian: '香港発アテネ行き航空券',
	xianggangkailuo: '香港発カイロ行き航空券',
	niuyuebeihaidao: 'ニューヨーク発北海道行き航空券',
	xianggangmilan: '香港発ミラノ行き航空券',
	xianggangbali: '香港発パリ行きの航空券',
	niuyueshengbaoluo: 'ニューヨーク発サンパウロ航空券',
	niuyueyatelanda: 'ニューヨークからアトランタへの航空券',
	xianbenna: '仙本那',
	malaixiya: 'マレーシア.',
	sulishi: 'チューリヒ',
	ruishi: 'スイス.',
	riyuetan: '日月潭',
	taiwan: '中国・台湾',
	xiyatu: 'シアトル.',
	huashengdun: 'アメリカ・ワシントン',
	mudidibiaoti1: '人気スポット',
	mudidimiaoshu1: '仙本の美しい景色',
	mudidibiaoti2: '人気スポット',
	mudidimiaoshu2: 'チューリッヒの美しい景色',
	mudidibiaoti3: '人気スポット',
	mudidimiaoshu3: '台湾の美しい景色',
	mudidibiaoti4: '人気スポット',
	mudidimiaoshu4: 'シアトルの美しい景色',
	mudidijingdianbiaoti1: 'カッパレ島',
	mudidijingdianmiaoshu1: 'カパーレ島は、青い海の上に浮かぶ幻想的な天国で、澄みきった底の海と色とりどりのサンゴ礁に囲まれて、まるで海に落ちたきらきらと輝く宝石のように、静かで活気に満ちている。',
	mudidijingdianbiaoti2: '敦沙カラン海洋公園',
	mudidijingdianmiaoshu2: '敦沙卡蘭海洋公園は、ダイビング、シュノーケリングだけでなく、徒歩で登山し、壮麗なパノラマを鑑賞し、現地の文化を体験し、探検と楽しみに満ちた旅をし、忘れられない思い出を得ることができます。',
	mudidijingdianbiaoti3: 'ティンバーティンバー島',
	mudidijingdianmiaoshu3: 'ティンバティンバ島は、過度に開発されていない静かな島で、原始的な自然と豊かな海洋生物で知られている。ここには澄んだ海水、美しいサンゴ礁、多様な海洋生物があり、潜水、シュノーケリング、心身をリラックスさせる絶好の場所です。島の環境は静かで、喧騒から離れ、自然に親しむ旅行者を求めるのに適している。',
	mudidijingdianbiaoti4: 'シバダン島',
	mudidijingdianmiaoshu4: 'シバダン島で潜水すると、群れをなしたウミガメ、サメ、ワタリガニと一緒に踊る機会があります。自然の壮麗さと不思議を感じることができます。これは忘れられない水中探検で、一生忘れられません。',
	mudidijingdianbiaoti5: '真珠島',
	mudidijingdianmiaoshu5: '真珠島では、太陽の光、砂浜、海水を満喫し、さまざまな水上活動を体験し、美しい海底世界を探索して自然の魅力を感じることができます。砂浜を歩いて、日の出と日の入りの壮麗な景色を楽しむこともできて、心を徹底的にリラックスさせることができます。',
	mudidijingdianbiaoti6: '軍艦島',
	mudidijingdianmiaoshu6: '軍艦島は、魅力的なビーチ、澄んだ海水、豊かな海洋生物で知られる活気と楽しみに満ちた島です。ここでは、シュノーケリングを楽しんだり、さまざまな海洋生物と触れ合ったり、海の魅力を感じたりすることができます。',
	mudidijingdianbiaoti7: 'チューリッヒ大聖堂',
	mudidijingdianmiaoshu7: 'チューリッヒ大聖堂は、その独特のツインタワーと雄大な建築様式で多くの観光客を魅了している。ここで歴史の重みを感じ、美しい芸術品を鑑賞し、タワーに登ってチューリッヒの美しい景色を見下ろすことができます。',
	mudidijingdianbiaoti8: 'スイス国立博物館',
	mudidijingdianmiaoshu8: 'スイス国立博物館は、知識と興味に満ちた博物館です。ここでスイスの歴史と文化を探索し、美しい芸術品を鑑賞し、スイスの独特な魅力を感じることができます。',
	mudidijingdianbiaoti9: 'チューリッヒ美術館',
	mudidijingdianmiaoshu9: 'チューリッヒ美術館（Kunsthaus Zürich）は、中世から現代までの様々な芸術作品を所蔵するスイスで最も重要な美術館の1つです。館内の所蔵品は絵画、彫刻、版画、撮影など、スイスと国際芸術家の作品を網羅している。印象派、表現主義、シュールなど、ジャンルの異なる芸術作品を楽しむことができます。',
	mudidijingdianbiaoti10: '聖母教会',
	mudidijingdianmiaoshu10: '聖母教会は、9世紀にさかのぼる歴史ある教会です。教会は宗教的な場所だけでなく重要文化財でもある。シャガールのステンドグラス窓のほか、教会内にはパイプオルガンや壁画など、鑑賞に値する芸術品がある。教会の尖塔もチューリッヒのシンボル的な景観の一つだ。',
	mudidijingdianbiaoti11: 'バンホフ通り',
	mudidijingdianmiaoshu11: 'バンホフ通りは、ショッピングの場所だけでなく、チューリッヒの中心地でもあります。この通りはチューリッヒ駅とチューリッヒ湖を結んでおり、観光客が必ず通る場所だ。ここでチューリッヒの都市風景を鑑賞し、この都市の繁栄と活力を感じることができます。また、通りの両側にはカフェやレストランがたくさんあり、休憩やリラックスを提供しています。',
	mudidijingdianbiaoti12: 'リンデンホフ山',
	mudidijingdianmiaoshu12: 'リンデンホフ山は、チューリッヒのシンボル的な観光地の一つです。ここでは、美しい都市の風景だけでなく、チューリッヒの歴史的な雰囲気も楽しむことができます。山頂の公園は地元住民がくつろげる良い場所で、ここで散歩したり、休んだりして、静かな時間を楽しむことができます。また、チューリッヒの全景を撮影するには絶好の場所でもあります。',
	mudidijingdianbiaoti13: '日月潭',
	mudidijingdianmiaoshu13: '日月潭（Sun Moon Lake）は、台湾で最も有名な観光地の一つであり、台湾最大の天然湖でもある。湖面はラル島によって区切られ、北側は太陽のように、南側は月のように形成されていることから名付けられた。日月潭の周りには山々が囲まれており、景色が美しく、湖や山の色が映えて趣がある。ここは美しい自然だけでなく、先住民文化も豊富で、台湾文化と自然を体験する理想的な場所です。',
	mudidijingdianbiaoti14: '九族文化村',
	mudidijingdianmiaoshu14: '九族文化村は、台湾の特色あるテーマパークであり、台湾の九大先住民族の文化をテーマに、各民族の生活様式、伝統芸術、建築の特色を展示している。ここでは先住民の伝統的な家を見学したり、すばらしい歌舞ショーを鑑賞したり、先住民の手芸を体験したり、刺激的なアトラクションに乗ったりすることができ、文化、娯楽、教育が一体となった総合的な楽園です。',
	mudidijingdianbiaoti15: '日月潭ロープウェイ',
	mudidijingdianmiaoshu15: '日月潭ケーブルカーは、最新のケーブルカー技術を採用し、快適で安全な乗り心地を実現しています。ケーブルカーは普通車両と水晶車両に分かれており、水晶車両の底は透明で、足元の美しい景色をより鮮明に鑑賞し、より刺激的な体験をすることができます。ケーブルカーは全行程約10分で上空からの美しい景色を楽しむことができ、日月潭観光には見逃せない体験です。',
	mudidijingdianbiaoti16: '阿里山国家景勝地',
	mudidijingdianmiaoshu16: '阿里山は、自然景観の代表であるだけでなく、台湾の文化の象徴でもある。ここには豊富な動植物資源があり、生態観光の理想的な場所である。森の遊歩道を歩いたり、新鮮な空気を吸ったり、美しい自然を楽しむことができます。また、阿里山の日の出と雲海は多くの観光客を引きつけ、台湾の高山の美しさを体験するための必須の観光地となっている。',
	mudidijingdianbiaoti17: '清境農場',
	mudidijingdianmiaoshu17: '清境農場は、台湾の有名な高山農場で、その優美な自然風景、ヨーロッパ風の建築とかわいいヒツジショーで有名で、高山農場の生活を体験する理想的な場所です。',
	mudidijingdianbiaoti18: '虹の眷村',
	mudidijingdianmiaoshu18: '虹眷村は、独特の彩色芸術で知られており、壁ごとに異なる色や模様があふれており、まるで童話の世界にいるようだ。ここを歩いて、いろいろな面白い絵を見て、芸術の魅力を感じることができます。また、虹の眷村の物語は多くの人を感動させ、周りの素晴らしいものをもっと大切にするようにしました。',
	mudidijingdianbiaoti19: 'スペースニードル',
	mudidijingdianmiaoshu19: 'スペースニードルは、米国シアトルの最も有名なランドマークの一つであり、その独特な造形と上部の展望台で有名な観光客は高速エレベーターで展望台に着くことができ、プーケット湾、オリンピック山脈、レイニール山などの壮麗な景色を含む360度死角のないシアトル都市の全景を楽しむことができる。スペースニードルはシアトルのシンボルであるだけでなく、重要な観光スポットでもある。',
	mudidijingdianbiaoti20: 'パークマーケット',
	mudidijingdianmiaoshu20: 'パーカー市場は、シアトルの中心部に位置し、活気と人情味に満ちた農業貿易市場です。ここには新鮮な海鮮から地元の農産物まで、さまざまな屋台があります。ここで美味しいご当地グルメを味わったり、大道芸人のパフォーマンスを楽しんだり、地元住民と交流したり、シアトルの独特な魅力を感じることができます。パークマーケットは驚きと楽しみに満ちた場所です。',
	mudidijingdianbiaoti21: 'キフテリアガラス芸術園',
	mudidijingdianmiaoshu21: '奇胡利ガラス芸術園は、独特のガラス芸術品と展示方法で知られている。ここを歩いて、さまざまな美しいガラス彫刻や装置を鑑賞して、ガラス芸術の独特な魅力を感じることができます。アートパーク内にはガラスハウスも設置されており、幻想的なガラスの世界に身を置いているかのような、キフテリアの大型ガラス装置が展示されています。キフーリガラス芸術園は芸術的な雰囲気と視覚的な楽しみに満ちた場所です。',
	mudidijingdianbiaoti22: 'ワシントン大学',
	mudidijingdianmiaoshu22: 'ワシントン大学は、アメリカ西海岸で最も有名な公立研究型大学の1つで、シアトルの中心部に位置しています。この大学はその美しいキャンパス、卓越した学術レベルと強大な研究実力で有名で、世界一流の図書館、実験室、研究センターを持っている。ワシントン大学は学術研究の殿堂であるだけでなく、活力と多元文化に満ちた場所でもある。',
	mudidijingdianbiaoti23: '飛行博物館',
	mudidijingdianmiaoshu23: '飛行博物館には、さまざまな飛行機だけでなく、インタラクティブな展示品やシミュレータがたくさんあり、臨場感を持って飛行を体験できます。ここでボーイング社の最初の工場を見学して、ボーイング社の発展の歴史を知ることができて、飛行シミュレータの楽しみを体験することもできます。飛行博物館は各年齢層の観光客が訪れるのに適したスポットで、航空ファンでも一般観光客でも、ここで楽しみを見つけることができます。',
	mudidijingdianbiaoti24: 'シアトル水族館',
	mudidijingdianmiaoshu24: 'シアトル水族館は、シアトルの浜辺にあり、太平洋北西部の海洋生物を展示する有名な水族館です。ラッコ、アザラシ、タコ、クラゲ、魚などさまざまな海洋生物がいます。ここではこれらのかわいい生物を間近で観察し、その習性や生息地を知ることができます。シアトル水族館は海の生き物を観賞する場所であるだけでなく、海の知識を学び、海の環境を守る場所でもあります。',
};
